export class QueryParams {
  static PAGE = 'page'

  static PAGE_SIZE = 'page-size'

  static PROJECT_NAME = 'project-name'
}
